import React, { useState } from "react";
import { Loader2, XCircle, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export function RetryButton({ task, s, onDone }) {
  const [busy, setBusy] = useState(false);
  const retry = async () => {
    setBusy(true);
    try { await api.post(`/tasks/${task.id}/steps/${s.id}/retry`); toast.success("Melanjutkan dari langkah ini — langkah yang sudah selesai tidak diulang"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal mencoba lagi"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 rounded-xl border border-red-200 bg-red-50 p-3" data-testid="wf-failed-panel">
      <p className="flex items-center gap-1.5 text-sm font-bold text-red-700"><XCircle size={15} /> Langkah ini gagal</p>
      {task.error && <p className="mt-0.5 break-words text-xs text-red-600" data-testid="wf-failed-error">{task.error}</p>}
      <p className="mt-0.5 text-xs text-red-600/80">Hasil langkah sebelumnya tetap tersimpan dan akan dipakai kembali sebagai masukan. Anda bisa mengubah langkah ini dulu (ikon pensil di kanan atas kartu), lalu coba lagi.</p>
      <button onClick={retry} disabled={busy} className="mt-2 flex items-center gap-1.5 rounded-lg bg-[#EF4444] px-4 py-2 text-xs font-bold text-white hover:brightness-105 disabled:opacity-60" data-testid="wf-retry">{busy ? <Loader2 size={13} className="animate-spin" /> : <RotateCcw size={13} />} Coba lagi dari langkah ini</button>
    </div>
  );
}
